<template>
  <div class="accordion" role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle="$slots.body ? accordionId : null" style="padding: 0 5px;">
          <slot name="button"></slot>
        </b-button>
      </b-card-header>
      <b-collapse :id="accordionId" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <slot name="body"></slot>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    accordionId: { type: String, default: 'accordionId' }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ui/display/Accordion.vue